import type {Response} from 'express';

export const sseClients: {
  id: string;
  connectedDate: Date;
  res: Response;
}[] = [];
